module.exports = __webpack_public_path__ + "static/media/raaz_img5.0acc9608.png";